import moment from "moment-business-days";

// Dates the business is closed for pickups: Czech public holidays plus
// the 31.12 company closure convention already used for 2024-2026.
// Covers 2026-2030 (fixed statutory dates + Good Friday/Easter Monday
// computed from each year's Easter Sunday, incl. 05.07/06.07 for
// Cyril and Methodius Day / Jan Hus Day). Extend as new years approach.
export const holidays = [
	"01.01.2026",
	"03.04.2026",
	"06.04.2026",
	"01.05.2026",
	"08.05.2026",
	"05.07.2026",
	"06.07.2026",
	"28.09.2026",
	"28.10.2026",
	"17.11.2026",
	"24.12.2026",
	"25.12.2026",
	"26.12.2026",
	"31.12.2026",

	"01.01.2027",
	"26.03.2027",
	"29.03.2027",
	"01.05.2027",
	"08.05.2027",
	"05.07.2027",
	"06.07.2027",
	"28.09.2027",
	"28.10.2027",
	"17.11.2027",
	"24.12.2027",
	"25.12.2027",
	"26.12.2027",
	"31.12.2027",

	"01.01.2028",
	"14.04.2028",
	"17.04.2028",
	"01.05.2028",
	"08.05.2028",
	"05.07.2028",
	"06.07.2028",
	"28.09.2028",
	"28.10.2028",
	"17.11.2028",
	"24.12.2028",
	"25.12.2028",
	"26.12.2028",
	"31.12.2028",

	"01.01.2029",
	"30.03.2029",
	"02.04.2029",
	"01.05.2029",
	"08.05.2029",
	"05.07.2029",
	"06.07.2029",
	"28.09.2029",
	"28.10.2029",
	"17.11.2029",
	"24.12.2029",
	"25.12.2029",
	"26.12.2029",
	"31.12.2029",

	"01.01.2030",
	"19.04.2030",
	"22.04.2030",
	"01.05.2030",
	"08.05.2030",
	"05.07.2030",
	"06.07.2030",
	"28.09.2030",
	"28.10.2030",
	"17.11.2030",
	"24.12.2030",
	"25.12.2030",
	"26.12.2030",
	"31.12.2030",
];

export const holidayFormat = "DD.MM.YYYY";
export const workingWeekdays = [1, 2, 3, 4, 5];

moment.updateLocale("cz", {
	holidays,
	holidayFormat,
	workingWeekdays,
});

export default moment;
